import { motion, AnimatePresence } from 'framer-motion';
import { X, ArrowRight } from 'lucide-react';
import { HORECA } from '@/constants/testIds';
import { resolveImg } from './adminConfig';

export default function CategoryModal({ category, onClose }) {
  return (
    <AnimatePresence>
      {category && (
        <motion.div
          className="fixed inset-0 z-[60] bg-[#1F1F1F]/70 backdrop-blur-sm flex items-end md:items-center justify-center p-0 md:p-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid={HORECA.categoryModal}
        >
          <motion.div
            className="bg-[#FBF7EE] text-[#1F1F1F] w-full max-w-4xl max-h-[92vh] overflow-y-auto"
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 40, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Başlık */}
            <div
              className="relative p-7 md:p-10 text-[#FBF7EE]"
              style={{ background: category.accent || '#1F1F1F' }}
            >
              <button
                onClick={onClose}
                data-testid={HORECA.categoryModalClose}
                className="absolute top-5 right-5 w-9 h-9 grid place-items-center border border-[#FBF7EE]/40 hover:bg-[#FBF7EE]/15 transition-colors"
                aria-label="Kapat"
              >
                <X className="w-4 h-4" />
              </button>
              {category.tag && (
                <span className="eyebrow text-[#FBF7EE]/80">{category.tag}</span>
              )}
              <h3 className="font-display text-4xl md:text-5xl leading-none mt-2">
                {category.name}
              </h3>
              {category.subtitle && (
                <p className="text-sm md:text-base font-body font-light text-[#FBF7EE]/85 mt-3">
                  {category.subtitle}
                </p>
              )}
            </div>

            <div className="p-7 md:p-10">
              {category.description && (
                <p className="text-[#5A5145] text-base md:text-lg leading-relaxed font-body font-light mb-8 max-w-2xl">
                  {category.description}
                </p>
              )}

              {(category.subcategories || []).length > 0 && (
                <>
                  <div className="eyebrow text-[#5A5145] mb-5">Alt Ürünler</div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {category.subcategories.map((s) => {
                      const img = resolveImg(s.image_url) || resolveImg(category.image_url);
                      return (
                        <div
                          key={s.id}
                          className="bg-[#FFFDF7] border border-[#1F1F1F]/12 overflow-hidden flex flex-col"
                          data-testid={`subcategory-item-${s.id}`}
                        >
                          <div className="relative bg-[#F3EEE2] aspect-[4/3] overflow-hidden flex items-center justify-center p-4">
                            {img ? (
                              <img
                                src={img}
                                alt={s.name}
                                className="max-h-full max-w-full object-contain"
                                loading="lazy"
                              />
                            ) : (
                              <span className="eyebrow text-[#5A5145]/50">Görsel yok</span>
                            )}
                          </div>
                          <div
                            className="px-4 py-3 border-t-2 flex-1"
                            style={{ borderColor: category.accent || '#B08834' }}
                          >
                            <div className="font-display text-lg md:text-xl leading-tight">
                              {s.name}
                            </div>
                            {s.description && (
                              <p className="text-xs md:text-sm font-body font-light text-[#5A5145] mt-1.5 leading-relaxed">
                                {s.description}
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}

              <div className="mt-9 pt-7 border-t border-[#1F1F1F]/12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <p className="text-sm text-[#5A5145] font-body max-w-md">
                  Bu grup için toplu fiyat, numune veya private label talebinizi iletin.
                </p>
                <a
                  href="#iletisim"
                  onClick={onClose}
                  className="inline-flex items-center gap-3 bg-[#1F1F1F] hover:bg-[#B03A2E] text-[#FBF7EE] px-8 py-4 text-xs tracking-[0.2em] transition-colors font-body whitespace-nowrap"
                >
                  TEKLİF AL
                  <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
